/* eslint-disable @typescript-eslint/no-explicit-any */

import { schema } from 'normalizr';

import { compact } from '../../../../helpers/compact';
import { FrequenciesEnum, Page, PageType } from '../../../../types/document';
import { toLink, toNumber, toRichText, toText } from '../../fields';
import { toFrequency } from '../../mapping';
import documentEntity from './document';

const processPage = (doc: any): Page =>
  compact({
    meta: compact({
      title: toText(doc.data?.meta_title) || toText(doc.data?.title),
      description: doc.data?.meta_description,
      image: doc.data?.meta_image,
      indexed: doc.data?.meta_indexing !== 'non',
    }),
    seoText: doc?.data?.seo_text,
    sitemapPriority: toNumber(doc.data?.sitemap_priority, {
      min: 0,
      max: 1,
      defaultValue: 0.8,
    }),
    sitemapChangeFrequency:
      toFrequency(doc.data?.sitemap_change_frequency) || FrequenciesEnum.WEEKLY,
    breadcrumbParent: toLink(doc?.data?.breadcrumb_parent),
    title: toText(doc?.data?.title),
    chapeau: toRichText(doc?.data?.chapeau),
  });

/**
 * Function to transform a prismic deprecated page to a document.
 *
 * @param type Type of document
 * @param opts Normalizr options
 * @returns the normalized document
 */
const deprecatedPageEntity = <T extends Page = Page>(
  type: PageType,
  { processStrategy, ...rest }: schema.EntityOptions<T>
): schema.Entity<T> =>
  documentEntity<T>(type, {
    processStrategy: (entity, parent, key) => ({
      ...processStrategy(entity, parent, key),
      ...processPage(entity),
    }),
    ...rest,
  });

export default deprecatedPageEntity;
